module.exports = __webpack_public_path__ + "static/img/itemBtnBg1.b88948a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/itemBtnBg1.png
// module id = gtZG
// module chunks = 0